import { render, staticRenderFns } from "./SubmenuDrawer.vue?vue&type=template&id=a3e56e12&scoped=true&"
import script from "./SubmenuDrawer.vue?vue&type=script&lang=ts&"
export * from "./SubmenuDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./SubmenuDrawer.vue?vue&type=style&index=0&id=a3e56e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e56e12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
